<script setup lang="ts">
import { Alert } from '@/shared/ui/Alert'

import { useAccount } from '../model/useAccount'

const { systemMessage, dismissSystemMessage } = useAccount()
</script>

<template>
  <Alert
    v-if="systemMessage"
    :title="systemMessage"
    type="warning"
    effect="dark"
    closable
    @close="dismissSystemMessage"
  />
</template>
